import * as api from "@/api/api";
import { ListSubscriptionsResponse } from "@/types/proto/exabel/user/external_subscription_service";

export const fetchSubscriptions = () =>
  api.get<ListSubscriptionsResponse>("v1/subscriptions");
